export const CONTAINER_MAX_WIDTH_UNITLESS = 1024;
export const CONTAINER_MAX_WIDTH = `${CONTAINER_MAX_WIDTH_UNITLESS}px`;

//This is ONLY to keep the Main Nav, Utility Nav, and Filter in sync, since buttons 'jump' from one to the other depending on the layout. This is NOT a global breakpoint for components and should never be used as such.
export const NAVIGATION_BREAKPOINT_UNITLESS = 875;
export const NAVIGATION_BREAKPOINT = `${NAVIGATION_BREAKPOINT_UNITLESS}px`;

//This is ONLY to handle the layout challenge of removing an element when the sidebar 'stacks'. This is NOT a global breakpoint for components and should never be used as such.
export const SIDEBAR_BREAKPOINT = `600px`;
export const ANCHOR_LINK_SCROLL_OFFSET = "90px";